var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoFounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.211 70.9999C141.211 109.435 110.065 140.58 71.6308 140.58C33.1961 140.58 2.05078 109.435 2.05078 70.9999C2.05078 32.5653 33.1961 1.41992 71.6308 1.41992C110.065 1.41992 141.211 32.5653 141.211 70.9999Z",
    fill: "url(#paint0_linear_1545_9264)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.4581 63.7855C92.0939 63.2134 90.8618 62.3773 89.7616 61.3212C89.5416 61.1011 89.3656 60.9251 89.1896 60.7051C89.0135 60.9251 88.7935 61.1451 88.6175 61.3212C87.5614 62.3773 86.3292 63.2134 84.921 63.7855C83.5129 64.4015 81.9727 64.7096 80.4325 64.7096C78.8923 64.7096 77.3521 64.4015 75.9439 63.7855C74.5798 63.2134 73.3476 62.3773 72.2475 61.3212C72.0275 61.1011 71.8514 60.9251 71.6754 60.7051C71.4994 60.9251 71.2794 61.1451 71.1033 61.3212C70.0472 62.3773 68.8151 63.2134 67.4069 63.7855C65.9987 64.4015 64.4585 64.7096 62.9184 64.7096C61.3782 64.7096 59.838 64.4015 58.4298 63.7855C57.0656 63.2134 55.8335 62.3773 54.7333 61.3212C54.5133 61.1011 54.3373 60.9251 54.1613 60.7051C53.9853 60.9251 53.7652 61.1451 53.5892 61.3212C52.5331 62.3773 51.3009 63.2134 49.8928 63.7855C48.4846 64.4015 46.9444 64.7096 45.4042 64.7096C43.952 64.7096 42.5439 64.4455 41.1797 63.9175V104.666C41.1797 105.459 41.7958 106.075 42.5879 106.075H78.0122C78.8043 106.075 79.4204 105.459 79.4204 104.666V74.5228C79.4204 73.7307 80.0364 73.1146 80.8285 73.1146H93.4581C94.2502 73.1146 94.8663 73.7307 94.8663 74.5228V104.666C94.8663 105.459 95.4823 106.075 96.2744 106.075H100.851C101.643 106.075 102.259 105.459 102.259 104.666V63.9175C100.939 64.4455 99.4868 64.7096 98.0346 64.7096C96.4064 64.7096 94.9103 64.4015 93.4581 63.7855ZM69.5632 92.741C69.5632 93.5331 68.9471 94.1492 68.155 94.1492H49.9368C49.1447 94.1492 48.5286 93.5331 48.5286 92.741V74.5228C48.5286 73.7307 49.1447 73.1146 49.9368 73.1146H68.155C68.9471 73.1146 69.5632 73.7307 69.5632 74.5228V92.741Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9273 44.5987L93.0624 35.9736H50.2892L43.4243 44.5987L36.6035 53.1357C36.6035 56.4361 38.4517 59.3405 41.1801 60.8367C42.4122 61.5408 43.8644 61.8928 45.4046 61.8928C50.2452 61.8928 54.1617 57.9763 54.1617 53.1357C54.1617 57.9763 58.0781 61.8928 62.9187 61.8928C67.7593 61.8928 71.6758 57.9763 71.6758 53.1357C71.6758 57.9763 75.5923 61.8928 80.4329 61.8928C85.2735 61.8928 89.1899 57.9763 89.1899 53.1357C89.1899 57.9763 93.1064 61.8928 97.947 61.8928C99.4872 61.8928 100.895 61.4968 102.172 60.8367C104.9 59.3405 106.748 56.4801 106.748 53.1357L99.9273 44.5987Z",
    fill: "#FFC25D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9264)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.6317,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#FFC25D",
    strokeWidth: 4.07895
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9264",
    x: 36.6035,
    y: 35.9736,
    width: 70.1445,
    height: 71.7327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9264",
    x: 8.20508,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9264",
    x1: 23.3508,
    y1: 16.5666,
    x2: 124.881,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoFounded);
export default __webpack_public_path__ + "static/media/IconGoFounded.a66877f2056ed0d7f3d01d185047e384.svg";
export { ForwardRef as ReactComponent };